import gql from 'graphql-tag';

export const getNotificationCount = gql`
  query financingAdminNotifications {
    financingAdminNotifications
  }
`;
